<script lang="ts">
    import { onMount } from "svelte";
    import Button from "../components/basic/button.svelte";
    import Layout from "../components/ui/layout.svelte";
    import { apiServer, sitekey } from "../constant";
    import Fa from 'svelte-fa';
    import { faClose } from '@fortawesome/free-solid-svg-icons';
    import { api_host, bpm_domain, bam_host } from '../store';
    import { doFetch } from "../components/utils/Fetching.svelte";
    import Swal from "sweetalert2";
    import { Recaptcha } from "svelte-recaptcha-v2";

    
    let pricing = {};
    let error = null;
    let modal_show = false;
    let domain_name = '';
    let plan_type = '';
    let is_domain_able = undefined;
    let is_busy = false;
    let recaptchaPass = false;
    let showDescription = {};

    onMount(async () => {
        window.scrollTo(0,0)

        fetch(apiServer + '/api/pricing?populate=pricing.plans.able_services.sub_service&populate=pricing.contact_form.background1', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            pricing = data.data.attributes.pricing;
        })
        .catch(e => error = e);
    });

    function toggleShowDescription(itemId) {
        showDescription[itemId] = !showDescription[itemId];
    }
</script>
<Layout>
    {#if Object.keys(pricing).length}
    <div class="container">
        <div class="title">
            {pricing['title']}
        </div>
        <div class="price-container">
            {#each pricing['plans'] as plan, i}
                {#if !plan.price}
                    <div class="price-card" style={`background-color: ${i === 2 ? "#F1F4EF" : "transparent"}`}>
                        <!-- <div class="kind">{plan.plan_title}</div> -->
                        <!-- <div class="price">
                            <span class="currency">$</span>
                            <span class="price-number">{plan.price}</span>
                            / month
                        </div>
                        <div style="font-size: 15px;">{plan.bill}</div>
                        <div class="description">{plan.plan_content}</div> -->
                        <div class={i === 2 ? "prime-choose" : "choose"}>
                            <Button disabled={plan.button_text === 'Coming Soon'} title={`${plan.button_text}`} on_click_func={() => {
                                // modal_show = true;
                                plan_type = plan.plan_title.toLowerCase();
                                window.location.href = `${$bam_host}/Contenthomepage/free?plan_type=${plan_type}&domain_name=sample`;
                            }} />
                        </div>
                        {#if (plan.feature)}
                            <div class="feature-title">{plan.feature}</div>
                        {/if}
                        {#each plan.able_services as able_service, j}
                            <div class="item-container">
                                <div class="key">{able_service.title}</div>
                                {#each able_service.items as item, k}
                                    <div class="item" on:click={() => toggleShowDescription(`${i}-${j}-${k}`)} style="cursor: pointer;">
                                        <div class="check-mark">
                                            <img src="/images_icon/check.svg" alt="check" />
                                        </div>
                                        <div style="flex-grow: 1; display: flex; justify-content: space-between;">
                                            <div class="item-text">{@html item['title']}</div>  
                                            {#if (!showDescription[`${i}-${j}-${k}`])} 
                                                <img src="/images_icon/arrow-right.svg" alt="Show Description" class="arrow-icon" />
                                            {:else}
                                                <img src="/images_icon/arrow-down.svg" alt="Hide Description" class="arrow-icon" />
                                            {/if}
                                        </div>
                                        
                                    </div>
                                    {#if (showDescription[`${i}-${j}-${k}`])}
                                    <div class="item-text" style="padding-top: 8px; padding-left: 24px;">{@html item['description']}</div>
                                    {/if}

                                {/each}
                            </div>
                        {/each}
                    </div>
                {/if}
            {/each}
        </div>
    </div>
    <div
        class="instant-section"
        style={`background-image: url(${apiServer + ((pricing['contact_form'] && pricing['contact_form'].background1.data) ? pricing['contact_form'].background1.data.attributes.url : '')});`}
    >
        <div class="instant">
            <div class="instant-text">{pricing['contact_form'].title}</div>
            <p class="instant-desc">{pricing['contact_form'].content}</p>
            <a href="tel:818-927-3458" class="tel">
                <Button title={pricing['contact_form'].button_text} />
            </a>
        </div>
    </div>
    {:else}
    <div class="loader-container">
        <div class="loader"/>
    </div>  
    {/if}
</Layout>

{#if modal_show}
<div class='modal_container'>
    <div class='modal_body'>
        <div class='modal_close_icon_container' on:click={() => { modal_show = false; }}>
            <Fa icon={faClose} size='2x' class='modal_close_icon' />
        </div>
        <h2>Type your company domain (website)</h2>
        <div class='subdomain-container'>
            <div class='input-group suffix'>
                <input type='text' name='input' bind:value={domain_name} disabled={false} on:input={(evt) => {
                    const subdomain_check = /^[a-zA-Z0-9-]+[a-zA-Z0-9]$/;
                    is_domain_able = true;
                    if (!evt.target['value'].match(subdomain_check)) {
                        is_domain_able = false;
                    }
                }} />
                <span class='input-group-addon'>.{$bpm_domain}</span>
            </div>
        </div>
        {#if !is_domain_able && is_domain_able !== undefined}
            <span style='color: red;margin-left: 5px;font-size: 13px;'>Incorrect domain name</span>
        {/if}
        {#if !recaptchaPass}
            <div style="width: 304px; margin: auto; margin-top: 10px;">
                <Recaptcha
                    id='googleRecaptcha'
                    style="margin: auto;"
                    sitekey={sitekey}
                    badge={"top"}
                    size={"visible"}
                    on:success={() => { setTimeout(() => {recaptchaPass = true}, 1000) }}
                    on:error={() => {console.log('error')}}
                    on:expired={() => {console.log('expired')}}
                    on:close={() => {console.log('close')}}
                    on:ready={() => {console.log('ready')}}
                />
            </div>
        {/if}
        <div class='modal_submit_btn'>
            <Button title={'Submit'} disabled={!is_domain_able || is_busy} on_click_func={async () => {
                if (!recaptchaPass) {
                    Swal.fire({
                        title: 'Warning',
                        text: 'Please verify that you are not a robot',
                        buttonStyling: true,
                        showCancelButton: false,
                        showConfirmButton: true,
                        icon: 'warning'
                    });
                    return;
                }
                is_busy = true;
                // const tempDomainTrial = localStorage.getItem('HoyDoMainTrial');
                const newDomainTrial = `${domain_name}`;
                const res = await doFetch(
                    `${$api_host}/api/ex/get/content/public`,
                    'POST',
                    { subdomain_name: newDomainTrial, is_new: true },
                    { 'Content-Type': 'application/json' }
                );
                if (res['status']) {
                    localStorage.setItem('HoyDoMainTrial', newDomainTrial);
                    window.location.href = `${$bam_host}/Contenthomepage/free?plan_type=${plan_type}&domain_name=${domain_name}`;
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: res.msg || 'Please try again later',
                        buttonsStyling: true,
                        cancelButtonText: "Cancel",
                        showCancelButton: true,
                        showConfirmButton: false,
                        icon: "warning"
                    });
                }
                is_busy = false;
            }} />
        </div>
    </div>
</div>
{/if}


<style src="../styles/price.css"></style>